import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ loyaltyInformation }: RootState) => loyaltyInformation;

export const selectLoyaltyInformation = createSelector(
    selectRoot,
    ({ loyaltyInformation }) => loyaltyInformation,
);
